"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowedOrigins = exports.Key = exports.getWidgetConfig = exports.initializeWidgetConfig = void 0;
var allowedOrigins_1 = require("./allowedOrigins");
Object.defineProperty(exports, "allowedOrigins", { enumerable: true, get: function () { return allowedOrigins_1.allowedOrigins; } });
var scriptTag = document.currentScript;
var tk = (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.getAttribute("tk")) || 'MwAKMDRPPjtoLsaJjfKdv9CUvaFHS6JJZFdCXDBd4salu76DiMuRqkcQdW9m8WE8YTeJn9XX4s6at7L0KDEmc1E9PQ..';
var parentOrigin = (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.getAttribute("parent-origin")) || 'unknown';
// Custom Base64 obfuscator
// Function to fetch widget configuration
var fetchWidgetConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response, data, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("https://internal.theconnexus.ai/api/widgets/foundPhrase", {
                        headers: {
                            'Content-Type': 'application/json',
                            'x-widget-token': tk
                        }
                    })];
            case 1:
                response = _a.sent();
                // console.log(response);
                if (!response.ok) {
                    throw new Error('Failed to fetch widget configuration');
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                data.data.parentOrigin = parentOrigin;
                // data.data.parentOrigin = 'http://localhost:4000';
                return [2 /*return*/, data];
            case 3:
                error_1 = _a.sent();
                console.error('Error fetching widget configuration:', error_1);
                // Return default configuration if fetch fails
                return [2 /*return*/, {}];
            case 4: return [2 /*return*/];
        }
    });
}); };
// Initialize widget configuration
var widgetConfig = null;
// Function to initialize the configuration
var initializeWidgetConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!!widgetConfig) return [3 /*break*/, 2];
                return [4 /*yield*/, fetchWidgetConfig()];
            case 1:
                widgetConfig = _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/, widgetConfig.data];
        }
    });
}); };
exports.initializeWidgetConfig = initializeWidgetConfig;
// Export the configuration getter
var getWidgetConfig = function () {
    if (!widgetConfig) {
        throw new Error('Widget configuration not initialized.');
    }
    // console.log('widgetConfig',widgetConfig)
    return widgetConfig.data;
};
exports.getWidgetConfig = getWidgetConfig;
exports.Key = '1b07e2d1-c19f-44de-a638-303e755e1477';
